export const LOGIN_INITIAL_STATE = {
    email: '',
    password: ''
}